import { CommonExport } from '../common/common-export.service';
import { setLastExportId } from 'modules/export/storage/last-export.storage';

export interface DownloadStatusResponse {
  total: number;
  page: number;
  data: Array<{
    _id: string;
    status: 'PENDING' | 'IN_PROGRESS' | 'DONE' | 'ERROR';
  }>;
}

export class AnalyticsDownloadService extends CommonExport<any> {
  _getExportPath = async (params: any, path?: string) => {
    const response = await this.getExportPath(path ?? '/conciliation/export', params);
    if (response?._id) {
      setLastExportId(response._id);
    }
    return response;
  };

  _generateDownload = () => this.generateDownload('/products/export/');
}

export default new AnalyticsDownloadService('/ms-analytics/api/v1');
